import { useFetcherData } from "v2/hooks/useFetcherData";

import { FetcherKeys } from "routes/dataroutes/Fetchers";
import { ApiKeysResponseType, path as ApiKeysDataPath } from "v2/api-key-management/routes/ApiKeysDataRoute";


export function useApiKeys(performInitialFetch: boolean = true) {
  const { value, reset, fetcher } = useFetcherData<ApiKeysResponseType, Promise<ApiKeysResponseType>>({
    fetcherKey: FetcherKeys.API_KEYS,
    fetcherHref: ApiKeysDataPath,
    performInitialFetch: performInitialFetch
  });

  return {
    apiKeys: value?.apiKeys,
    apiKey: value?.apiKeys?.[0],
    apiKeysFetcher: fetcher!,
    reloadApiKeys: () => reset(false)
  };
}
